module.exports = __webpack_public_path__ + "img/9.79b29a1.webp";